import React from 'react';
import {usePaymentContext} from '../../contexts/PaymentContext';
import {usePaymentPaypalContext} from '../../contexts/PaymentPaypalContext';
import InputCustomerLink from '../InputCustomerLink';

const FieldCustomerLinkPaypal = () => {
  const {loadCustomerOptions, onCustomerChanged, updateForm} = usePaymentPaypalContext();
  const {invoiceOrder} = usePaymentContext();

  return (
    <InputCustomerLink
      loadCustomerOptions={loadCustomerOptions}
      onCustomerChanged={onCustomerChanged}
      updateForm={updateForm}
      invoiceOrder={invoiceOrder}
    />
  );
};

export default FieldCustomerLinkPaypal;